import React, { memo, useCallback, useMemo, useState } from 'react';

import ClosingCompanyForm from 'app/pages/loanApplication/tabs/loanClosingCDS/shared/ClosingCompanyForm';
import PropTypes from 'prop-types';

const ClosingCompanyModalContent = ({ applicationId, closingCompany, onClose }) => {
  const [isLoading, setIsLoading] = useState(false);

  const pendingChangesData = useMemo(() => ({}), []);

  const onExitEditMode = useCallback(() => {
    onClose();
  }, [onClose]);

  return (
    <ClosingCompanyForm
      applicationId={applicationId}
      closingCompany={closingCompany}
      isLoading={isLoading}
      pendingChangesData={pendingChangesData}
      setIsLoading={setIsLoading}
      onExitEditMode={onExitEditMode}
    />
  );
};

ClosingCompanyModalContent.propTypes = {
  applicationId: PropTypes.string.isRequired,
  closingCompany: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default memo(ClosingCompanyModalContent);
